import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import nodata from "../../../Utils/assets/img/leads_no_data_found.png"

const UserNode = ({
    userId,
    userData,
    level = 0,
    onToggle,
    isExpanded,
    expandedNodes,
    showChildren = true,
    serial
}) => {
    const hasChildren = userData.children && userData.children.length > 0;

    return (
        <div>
            <div
                className="d-flex align-items-center border-bottom py-2"
                style={{ marginLeft: `${level * 10}px` }}
                onClick={() => hasChildren && onToggle && onToggle(userId)}
            >

                <div style={{ cursor: "pointer" }} className="flex-grow-1 d-flex align-items-center">
                    {hasChildren ? (
                        isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />
                    ) : (
                        <span className="me-3" />
                    )}
                    <span className="ms-2">{userData.name}</span>
                </div>

                <div className="text-center" style={{ width: "150px" }}>
                    {userData.code || "-"}
                </div>

                <div className="text-center" style={{ minWidth: "150px" }}>
                    {userData.type || "-"}
                </div>
            </div>

            {hasChildren && showChildren && isExpanded &&
                userData.children.map((child, index) => (
                    <UserTreeNode
                        key={child.id}
                        userId={child.id}
                        userData={child}
                        level={level + 1}
                        onToggle={onToggle}
                        expandedNodes={expandedNodes}
                        serial={`${serial}.${index + 1}`}
                    />
                ))}
        </div>
    );
};


const UserTreeNode = ({ userId, userData, level = 0, onToggle, expandedNodes }) => {
    if (!userData) return null;

    const isExpanded = expandedNodes ? expandedNodes?.has(userId) : true;

    return (
        <UserNode
            userId={userId}
            userData={userData}
            level={level}
            onToggle={onToggle}
            isExpanded={isExpanded}
            expandedNodes={expandedNodes}
            showChildren
        />
    );
};

const buildHierarchy = (data) => {
    if (!data) return
    const map = {};
    const roots = [];
    data?.forEach(item => {
        map[item.id] = {
            id: item.id,
            name: item.account_name,
            code: item.account_code,
            type: item.title,
            avatar: item.avatar,
            children: []
        };
    });

    data.forEach(item => {
        if (item.parent_id) {
            map[item.parent_id]?.children.push(map[item.id]);
        } else if (item.parent_id === null) {
            roots.push(map[item.id]);
        }
    });

    return roots;
};

export const TreeView = ({ data }) => {
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const hierarchyData = buildHierarchy(data);

    const toggleNode = (userId) => {
        const newExpanded = new Set(expandedNodes);
        if (newExpanded.has(userId)) newExpanded.delete(userId);
        else newExpanded.add(userId);
        setExpandedNodes(newExpanded);
    };

    return (
        <div className="tree-container border rounded" style={{ backgroundColor: "white" }}>

            <div className="d-flex fw-bold border-bottom py-2" style={{ backgroundColor: "white" }}>
                <div className="flex-grow-1 text-left">Account Name</div>
                <div className="text-center" style={{ width: "150px" }}>Account Code</div>
                <div className="text-center" style={{ width: "150px" }}>Account Type</div>
            </div>

            {
                hierarchyData?.length !== 0 ?
                    hierarchyData?.map((rootNode, index) => (
                        <UserTreeNode
                            key={rootNode.id}
                            userId={rootNode.id}
                            userData={rootNode}
                            level={0}
                            onToggle={toggleNode}
                            expandedNodes={expandedNodes}
                            serial={index + 1}
                        />
                    ))

                    :
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style={{ position: "", left: "", paddingTop: "4rem" }}
                    >
                        <img
                            src={nodata}
                            alt=""
                            style={{ width: "17rem", marginTop: "0" }}
                        />
                    </div>
            }
        </div>
    );
};